import { Routes, Route, Navigate } from "react-router-dom";
import FirstPage from "./components/FirstPage";
import { ChakraProvider } from "@chakra-ui/react";
import Dashboard from "./components/Dashboard";
import AboutPage from "./components/About";
import ContactPage from "./components/Contact";
import DashboardMeal from "./components/DashboardMeal";
import DashboardMealvsReal from "./components/DashboardMealvsReal";

import DashboardMaster from "./components/DashboardMaster";
import { useState, useEffect } from "react";

function App() {
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem('userEmail') || '');

  // Cuma simpen, jangan hapus otomatis
  useEffect(() => {
    if (userEmail) {
      localStorage.setItem('userEmail', userEmail);
    }
  }, [userEmail]);

  return (
    <ChakraProvider>
      <Routes>
        <Route path="/" element={<FirstPage setUserEmail={setUserEmail} />} />
        <Route path="/dashboard" element={<Dashboard userEmail={userEmail} setUserEmail={setUserEmail} />} />
        <Route path="/dashboard-meal" element={<DashboardMeal userEmail={userEmail} />} />
        <Route path="/dashboard-meal-real" element={<DashboardMealvsReal userEmail={userEmail} />} />
        <Route path="/dashboard-master" element={<DashboardMaster userEmail={userEmail} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ChakraProvider>
  );
}

export default App;